import styled from '@emotion/styled';
import { FC } from 'react';
import { IconClose24 } from 'components/base/Icon';
import Text from 'components/base/Text';
import { border4, white } from 'styles';

interface Props {
  onClose: () => void;
}

/**
 * 검색 필터 - 헤더
 * @component
 */
const Header: FC<Props> = ({ onClose }) => {
  return (
    <SC.Container>
      <Text variant='title4_medium' color='gray_primary' alignment='center' ml={24}>
        필터 검색
      </Text>
      <IconClose24 onClick={onClose} />
    </SC.Container>
  );
};
export default Header;

const SC = {
  Container: styled.header`
    position: sticky;
    display: grid;
    padding: 12px 16px;
    grid-template-columns: 1fr 24px;
    width: 100%;
    height: 48px;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: ${white};
    border-bottom: 1px solid ${border4};

    svg {
      cursor: pointer;
    }
  `,
};
